import { render, staticRenderFns } from "./SummaryShiftsGroup.vue?vue&type=template&id=d5aa665e&"
import script from "./SummaryShiftsGroup.vue?vue&type=script&lang=js&"
export * from "./SummaryShiftsGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports